import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navItems = [{
  label: 'Home',
  href: '#hero'
}, {
  label: 'The Problem',
  href: '#problem'
}, {
  label: "What's Inside",
  href: '#modules'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'Guarantee',
  href: '#guarantee'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function FloatingNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (href: string) => {
    // Close mobile menu first
    setIsMobileMenuOpen(false);
    // Small delay to let menu close, then scroll
    setTimeout(() => {
      const element = document.querySelector(href);
      if (element) {
        // Get the fixed nav height (64px on mobile, 80px on desktop)
        const navHeight = window.innerWidth >= 768 ? 80 : 64;
        // Get element position relative to viewport
        const elementPosition = element.getBoundingClientRect().top;
        // Calculate scroll position using modern window.scrollY
        const offsetPosition = elementPosition + window.scrollY - navHeight;
        // Scroll to position with offset
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`} data-id="element-95">
        <div className="max-w-7xl mx-auto px-4" data-id="element-96">
          <div className="flex items-center justify-between h-16 md:h-20" data-id="element-97">
            {/* Logo/Brand */}
            <button onClick={() => scrollToSection('#hero')} className="flex items-center gap-2 hover:opacity-80 transition-opacity" aria-label="Mega Music Pack - Go to home" data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/m1JpTPEWcSNayUDDPZu77c/LOGO_T.png" alt="Mega Teacher Pack Logo" className="h-12 md:h-16 w-auto" data-id="element-99" />
            </button>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-6 lg:gap-8" data-id="element-100">
              {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="text-sm font-medium text-charcoal hover:text-navy transition-colors" data-id="element-101">
                  {item.label}
                </button>)}
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-navy" aria-label="Toggle menu" data-id="element-102">
              {isMobileMenuOpen ? <X className="w-5 h-5" data-id="element-103" /> : <Menu className="w-5 h-5" data-id="element-104" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-105">
          {isMobileMenuOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="md:hidden overflow-hidden bg-white border-t border-gray-200" data-id="element-106">
              <div className="px-4 py-3 space-y-1" data-id="element-107">
                {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="block w-full text-left px-3 py-2 text-sm font-medium text-charcoal hover:bg-cream hover:text-navy transition-colors rounded" data-id="element-108">
                    {item.label}
                  </button>)}
              </div>
            </motion.div>}
        </AnimatePresence>
      </motion.nav>

      {/* Spacer to prevent content from hiding under fixed nav */}
      <div className="h-16 md:h-20" data-id="element-109" />
    </>;
}